import { dev } from "./environments/dev";
import { production } from "./environments/prod";
import { uat } from "./environments/uat";

let config;

switch (process.env.REACT_APP_STAGE) {
  case "dev":
    config = dev;
    break;
  case "prod":
    config = production;
    break;
  case "uat":
    config = uat;
    break;
  default:
    config = dev;
}

export const appConfig = {
  ...config,
  appName: "Prepaid Card Manager",
  apiName: "prepaid-card-management",
  apiVersion: "api/v1",

  get apiBaseUrl() {
    return `/${this.apiName}/${this.apiVersion}`;
  },
};
